import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';
import { getFingerprint } from '../../utils/fingerprint';

/**
 * 指纹拦截器
 * @description 为请求添加 X-Signature-ID header
 */
export const fingerprintInterceptor = async(config: any) => {
    config.headers = _.merge({}, config.headers, {
        'X-Signature-ID': await getFingerprint(),
    });
    return config;
};

/**
 * 注入指纹拦截器
 */
export function injectFingerprintInterceptor() {
    if (!psAxios.psInterceptors.fingerprintInterceptor) {
        psAxios.psInterceptors.fingerprintInterceptor = psAxios.interceptors.request.use(
            fingerprintInterceptor,
            () => { },
        );
    }
}

/**
 * 移除指纹拦截器
 */
export function ejectFingerprintInterceptor() {
    if (psAxios.psInterceptors.fingerprintInterceptor) {
        psAxios.interceptors.request.eject(psAxios.psInterceptors.fingerprintInterceptor);
        delete psAxios.psInterceptors.fingerprintInterceptor;
    }
}
